module.exports = __webpack_public_path__ + "img/projects-img2.6c4cc116.jpg";